var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBaselineRequestQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-request-quote"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9138 2.16669H5.24717C4.33051 2.16669 3.58884 2.91669 3.58884 3.83335L3.58051 17.1667C3.58051 18.0834 4.32217 18.8334 5.23884 18.8334H15.2472C16.1638 18.8334 16.9138 18.0834 16.9138 17.1667V7.16669L11.9138 2.16669ZM12.7472 10.5H9.41384V11.3334H11.9138C12.3722 11.3334 12.7472 11.7084 12.7472 12.1667V14.6667C12.7472 15.125 12.3722 15.5 11.9138 15.5H11.0805V16.3334H9.41384V15.5H7.74717V13.8334H11.0805V13H8.58051C8.12217 13 7.74717 12.625 7.74717 12.1667V9.66669C7.74717 9.20835 8.12217 8.83335 8.58051 8.83335H9.41384V8.00002H11.0805V8.83335H12.7472V10.5ZM11.0805 7.16669V3.41669L14.8305 7.16669H11.0805Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBaselineRequestQuote);
export default __webpack_public_path__ + "static/media/ic_baseline-request-quote.fb67b9de42f91ecdba07856be9ce41b9.svg";
export { ForwardRef as ReactComponent };